var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCreditor',{attrs:{"header":"ใบ PU","img_header":_vm.header_image,"link_back":"creditor/puinvoice"}}),_c('PU_details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }